module.exports = __webpack_public_path__ + "img/icon_1_color@4x.d70a2155.png";